import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';

import Fido from "../utils/Fido";
import Activity from "./Activity";

function AnonymousActivity(props) {
	const [activity, setActivity] = useState(null);
	const [fidoError, setFidoError] = useState(false);
	// so we can avoid trying to update state on unmounted component (ie loadMore())
	const isMountedRef = useRef(true);

	let {location, updateHeader, resetHeader, showSnackbar, unauthenticated} = props;

	useEffect(() => {
		if (unauthenticated === true) {
			(async () => {
				let anonFido = new Fido(),
					resp = await anonFido.fetch(location.pathname)
						.catch((error) => {
							setFidoError(true);
							if(error.message === "404 Not Found") {
								showSnackbar({
									message: "Not found. Outdated?",
									duration: false
								});
							} else {
								showSnackbar(error.message);
							}
						});

				if (resp && isMountedRef.current) {
					setActivity(resp.activity);
				}
			})();
		}
	}, [unauthenticated, location.pathname, showSnackbar, setFidoError]);

	return (
		<Activity
			{...props}
			activity={activity}
			fidoError={fidoError}
			updateHeader={updateHeader}
			resetHeader={resetHeader}
			showSnackbar={showSnackbar} />
	);
}

AnonymousActivity.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	location: PropTypes.object,
	unauthenticated: PropTypes.bool
};

export default AnonymousActivity;